import axios from 'axios';
import store from '../store';
import { setClientVersion } from '../utils';
import Cookies from 'cookies-js';
import { reportError } from '../utils/report-error';

export const localAxios = axios.create({
  withCredentials: true,
  responseType: 'json',
  headers: {
    'Content-Type': 'application/json',
  },
});

localAxios.interceptors.request.use((config) => {
  config.headers['X-CSRF-Token'] = store.getters.csrfToken;

  return config;
});

localAxios.interceptors.response.use(
  (response) => {
    checkHeaders(response);

    if (Cookies.get('campsite_profile'))
      store.commit('profiles/set', {
        name: 'currentId',
        value: Cookies.get('campsite_profile'),
      });

    return response;
  },
  (error) => {
    checkHeaders(error.response);

    // Report API errors to Sentry via reportError (handles fingerprinting,
    // tagging, and 401/cancellation filtering internally)
    reportError(error);

    return Promise.reject(error);
  },
);

axios.interceptors.response.use(undefined, (error) => {
  reportError(error);

  return Promise.reject(error);
});

function checkHeaders(response) {
  if (!response || !response.headers) return;

  if (response.headers['x-client-version'])
    setClientVersion(response.headers['x-client-version']);
  if (response.headers['x-maintenance-mode'])
    store.dispatch(
      'tryUpdateMaintenanceMode',
      response.headers['x-maintenance-mode'] === 'true' ? true : false,
    );
}
